import withPresenter from './EditorContext.presenter';
import withInteractor from './EditorContext.interactor';
import EditorContextView, { EditorContext } from './EditorContext';

export { EditorContext };

const EditorContextProvider = withInteractor(withPresenter(EditorContextView));

export default EditorContextProvider;
